import React from "react";
import { Stack, Button } from "@mui/material";
import { AddCircle } from "@mui/icons-material";

interface Props {
  isLoading: boolean;
  isUpdating?: boolean;
  handleAddRow: VoidFunction;
}

export const BottomActionPanel = ({ handleAddRow, isLoading, isUpdating }: Props) => {
  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button disabled={isLoading || isUpdating} startIcon={<AddCircle />} size="small" onClick={handleAddRow}>
        Add Tier
      </Button>
    </Stack>
  );
};
